export default "https://assets.egbcdn.net/assets/packs/_/videos/lootbox/video-dota-251290e6aad6d9ae73bc8d71ba83fc44.mp4";